import React from 'react';
import { useSelector } from 'react-redux';
import { AspectRatio } from '@yme/atoms/aspect-ratio';
import { CustomPlaceholder } from '@yme/atoms/custom-placeholder';
import { GridWrapper } from '@yme/atoms/grid';
import { VideoPlayer } from '@yme/atoms/video-player';
import { IndentWrapper } from '@yme/components/Separator';
import { useIsShowCustomPlaceholder } from '@yme/hooks/index';
import { getIsLoadedProductDetails } from '@yme/selectors/products';
import { buildYoutubeUrl } from '@yme/utils/common';
import { AspectRatio as AspectRationEnum } from '@yme/utils/constants';
import { getTitleAttributeSelector } from '../ProductCard';
import { ProductVideoSkeleton } from './ProductVideoSkeleton';
import { getYoutubeId } from './selectors';
export function ProductVideo({ isRemoveBottomIndent, isInEditor, }) {
    const youTubeId = useSelector(getYoutubeId);
    const titleAttribute = useSelector(getTitleAttributeSelector);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const isShowCustomPlaceholder = useIsShowCustomPlaceholder();
    if (!isLoadedProductDetails && !isInEditor) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(ProductVideoSkeleton, null)));
    }
    if (isInEditor && isShowCustomPlaceholder && !youTubeId) {
        return React.createElement(CustomPlaceholder, { title: "Product Video" });
    }
    if (!youTubeId) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(GridWrapper, null,
            React.createElement(AspectRatio, { ratio: AspectRationEnum.RectangleLevel4 },
                React.createElement(VideoPlayer, { videoPath: buildYoutubeUrl(youTubeId), title: titleAttribute?.value })))));
}
